module.exports = __webpack_public_path__ + "static/img/image-benefit.c6a8c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/doublelift/image-benefit/image-benefit.png
// module id = 2aAb
// module chunks = 35